const collections = [
  {
    title: '2026上半年娱乐圈出轨盘点',
    count: '23篇',
    desc: '半年来最全的明星出轨事件汇总与分析',
    icon: 'ri-file-list-3-line',
  },
  {
    title: '选秀节目黑幕专题',
    count: '18篇',
    desc: '从投票造假到导师索贿，选秀圈乱象全记录',
    icon: 'ri-spy-line',
  },
  {
    title: '明星税务风波追踪',
    count: '15篇',
    desc: '娱乐圈偷税漏税案件持续跟进',
    icon: 'ri-money-cny-circle-line',
  },
  {
    title: '顶流艺人私生活揭秘',
    count: '31篇',
    desc: '当红明星不为人知的另一面',
    icon: 'ri-user-search-line',
  },
  {
    title: '娱乐圈人设崩塌档案',
    count: '27篇',
    desc: '那些年崩塌的完美人设，一个个让人唏嘘',
    icon: 'ri-file-warning-line',
  },
  {
    title: '影视剧组内幕爆料合集',
    count: '19篇',
    desc: '片场冲突、演员不和、潜规则等内幕',
    icon: 'ri-clapperboard-line',
  },
  {
    title: '女团成员恋情时间线',
    count: '12篇',
    desc: '偶像恋爱实锤证据与完整时间线梳理',
    icon: 'ri-heart-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按主题分类的吃瓜专题，帮你系统性地追踪每一条线索
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collections.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group bg-background-50 rounded-lg p-5 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg mb-4">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="text-[10px] text-primary-500 font-medium">
                {item.count} · 持续更新
              </span>
            </a>
          ))}
          {collections.slice(3).map((item, i) => (
            <a
              key={i + 3}
              href="#index"
              className="group bg-background-50 rounded-lg p-5 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-4">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 leading-relaxed mb-3">
                {item.desc}
              </p>
              <span className="text-[10px] text-accent-600 font-medium">
                {item.count} · 持续更新
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}